export default {
    setXmppCreds({ commit }, xmppParams) {
        commit("_setXmppCreds", xmppParams);
    },
};
